"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddBattleEventDTO = exports.GetByBattleIdDTO = exports.LootSummaryDTO = exports.OpenChestDTO = exports.InitialMonsterWaveDTO = exports.GenericMonsterWaveDTO = exports.ArenaWaveSpawnDTO = exports.TimeoutEventDTO = exports.EndBattleEventDTO = exports.GoalInitEventDTO = exports.GoalEventDTO = exports.TargetCharacterDTO = exports.ImpactDTO = exports.SkillEventDTO = exports.PositionCharactersEventDTO = exports.CharacterPositionDTO = exports.UserLoseEventDTO = exports.AddCharacterEventDTO = exports.AddUserEventDTO = exports.BattleUserDTO = exports.EndTurnEventDTO = exports.StartBattleEventDTO = exports.BattleEventListDTO = exports.BattleEventDTO = exports.PointDTO = exports.EndBattleReasons = exports.BattleEventsTypes = exports.BattleEventCsharpTypes = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const Battle_1 = require("./Battle");
const Character_1 = require("./Character");
const Skill_1 = require("./Skill");
var BattleEventCsharpTypes;
(function (BattleEventCsharpTypes) {
    BattleEventCsharpTypes["Timeout"] = "LoneStoneStudio.CityInvaders.TimeoutEventDTO, CityInvaders.Runtime";
    BattleEventCsharpTypes["AddUser"] = "LoneStoneStudio.CityInvaders.AddUserEventDTO, CityInvaders.Runtime";
    BattleEventCsharpTypes["UserLose"] = "LoneStoneStudio.CityInvaders.UserLoseEventDTO, CityInvaders.Runtime";
    BattleEventCsharpTypes["EndBattle"] = "LoneStoneStudio.CityInvaders.EndBattleEventDTO, CityInvaders.Runtime";
    BattleEventCsharpTypes["EndTurn"] = "LoneStoneStudio.CityInvaders.EndTurnEventDTO, CityInvaders.Runtime";
    BattleEventCsharpTypes["Skill"] = "LoneStoneStudio.CityInvaders.SkillEventDTO, CityInvaders.Runtime";
})(BattleEventCsharpTypes = exports.BattleEventCsharpTypes || (exports.BattleEventCsharpTypes = {}));
var BattleEventsTypes;
(function (BattleEventsTypes) {
    BattleEventsTypes["StartBattle"] = "StartBattle";
    BattleEventsTypes["EndTurn"] = "EndTurn";
    BattleEventsTypes["AddUser"] = "AddUser";
    BattleEventsTypes["UserLose"] = "UserLose";
    BattleEventsTypes["AddCharacter"] = "AddCharacter";
    BattleEventsTypes["PositionCharacters"] = "PositionCharacters";
    BattleEventsTypes["Skill"] = "Skill";
    BattleEventsTypes["Goal"] = "Goal";
    BattleEventsTypes["EndBattle"] = "EndBattle";
    BattleEventsTypes["Timeout"] = "Timeout";
    BattleEventsTypes["SpawnArena"] = "SpawnArena";
    BattleEventsTypes["GenericMonsterWave"] = "GenericMonsterWave";
    BattleEventsTypes["OpenChest"] = "OpenChest";
    BattleEventsTypes["GoalInit"] = "GoalInit";
    BattleEventsTypes["InitialMonsterWave"] = "InitialMonsterWave";
    BattleEventsTypes["LootGeneration"] = "LootGeneration";
    BattleEventsTypes["LootPickup"] = "LootPickup";
    BattleEventsTypes["LootChestDrop"] = "LootChestDrop";
    BattleEventsTypes["LootBundleDrop"] = "LootBundleDrop";
})(BattleEventsTypes = exports.BattleEventsTypes || (exports.BattleEventsTypes = {}));
var EndBattleReasons;
(function (EndBattleReasons) {
    EndBattleReasons["Goal"] = "Goal";
    EndBattleReasons["Surrender"] = "Surrender";
    EndBattleReasons["Timeout"] = "Timeout";
    EndBattleReasons["Deathmatch"] = "Deathmatch";
    EndBattleReasons["TimeoutSideEffect"] = "TimeoutSideEffect";
})(EndBattleReasons = exports.EndBattleReasons || (exports.EndBattleReasons = {}));
let PointDTO = (() => {
    class PointDTO {
    }
    __decorate([
        class_validator_1.IsNumber(),
        __metadata("design:type", Number)
    ], PointDTO.prototype, "X", void 0);
    __decorate([
        class_validator_1.IsNumber(),
        __metadata("design:type", Number)
    ], PointDTO.prototype, "Y", void 0);
    return PointDTO;
})();
exports.PointDTO = PointDTO;
let BattleEventDTO = (() => {
    class BattleEventDTO {
    }
    __decorate([
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], BattleEventDTO.prototype, "id", void 0);
    __decorate([
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], BattleEventDTO.prototype, "battleId", void 0);
    __decorate([
        class_validator_1.IsEnum(BattleEventsTypes),
        __metadata("design:type", String)
    ], BattleEventDTO.prototype, "type", void 0);
    __decorate([
        class_validator_1.IsDate(),
        class_validator_1.IsOptional(),
        __metadata("design:type", Date)
    ], BattleEventDTO.prototype, "time", void 0);
    __decorate([
        class_validator_1.IsString(),
        class_validator_1.IsOptional(),
        __metadata("design:type", String)
    ], BattleEventDTO.prototype, "linkedBattleEventId", void 0);
    return BattleEventDTO;
})();
exports.BattleEventDTO = BattleEventDTO;
let BattleEventListDTO = (() => {
    class BattleEventListDTO {
    }
    __decorate([
        class_validator_1.IsArray(),
        class_transformer_1.Type(() => BattleEventDTO),
        class_validator_1.ValidateNested(),
        __metadata("design:type", Array)
    ], BattleEventListDTO.prototype, "events", void 0);
    return BattleEventListDTO;
})();
exports.BattleEventListDTO = BattleEventListDTO;
let StartBattleEventDTO = (() => {
    class StartBattleEventDTO extends BattleEventDTO {
    }
    __decorate([
        class_validator_1.IsUUID(),
        __metadata("design:type", String)
    ], StartBattleEventDTO.prototype, "startTurnUserId", void 0);
    return StartBattleEventDTO;
})();
exports.StartBattleEventDTO = StartBattleEventDTO;
let EndTurnEventDTO = (() => {
    class EndTurnEventDTO extends BattleEventDTO {
    }
    __decorate([
        class_validator_1.IsUUID(),
        __metadata("design:type", String)
    ], EndTurnEventDTO.prototype, "endTurnUserId", void 0);
    __decorate([
        class_validator_1.IsUUID(),
        __metadata("design:type", String)
    ], EndTurnEventDTO.prototype, "startTurnUserId", void 0);
    return EndTurnEventDTO;
})();
exports.EndTurnEventDTO = EndTurnEventDTO;
let BattleUserDTO = (() => {
    class BattleUserDTO {
    }
    __decorate([
        class_validator_1.IsUUID(),
        __metadata("design:type", String)
    ], BattleUserDTO.prototype, "id", void 0);
    __decorate([
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], BattleUserDTO.prototype, "username", void 0);
    __decorate([
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], BattleUserDTO.prototype, "avatarId", void 0);
    __decorate([
        class_validator_1.IsEnum(Battle_1.Teams),
        __metadata("design:type", String)
    ], BattleUserDTO.prototype, "team", void 0);
    __decorate([
        class_validator_1.IsNumber(),
        __metadata("design:type", Number)
    ], BattleUserDTO.prototype, "turnOrder", void 0);
    __decorate([
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], BattleUserDTO.prototype, "ai", void 0);
    __decorate([
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], BattleUserDTO.prototype, "lost", void 0);
    __decorate([
        class_validator_1.IsNumber(),
        __metadata("design:type", Number)
    ], BattleUserDTO.prototype, "score", void 0);
    return BattleUserDTO;
})();
exports.BattleUserDTO = BattleUserDTO;
let AddUserEventDTO = (() => {
    class AddUserEventDTO extends BattleEventDTO {
    }
    __decorate([
        class_transformer_1.Type(() => BattleUserDTO),
        class_validator_1.ValidateNested(),
        __metadata("design:type", BattleUserDTO)
    ], AddUserEventDTO.prototype, "battleUser", void 0);
    return AddUserEventDTO;
})();
exports.AddUserEventDTO = AddUserEventDTO;
class AddCharacterEventDTO extends BattleEventDTO {
}
exports.AddCharacterEventDTO = AddCharacterEventDTO;
let UserLoseEventDTO = (() => {
    class UserLoseEventDTO extends BattleEventDTO {
    }
    __decorate([
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], UserLoseEventDTO.prototype, "userId", void 0);
    __decorate([
        class_validator_1.IsEnum(EndBattleReasons),
        __metadata("design:type", String)
    ], UserLoseEventDTO.prototype, "reason", void 0);
    return UserLoseEventDTO;
})();
exports.UserLoseEventDTO = UserLoseEventDTO;
let CharacterPositionDTO = (() => {
    class CharacterPositionDTO extends BattleEventDTO {
    }
    __decorate([
        class_validator_1.IsUUID(),
        __metadata("design:type", String)
    ], CharacterPositionDTO.prototype, "characterId", void 0);
    __decorate([
        class_transformer_1.Type(() => PointDTO),
        class_validator_1.ValidateNested(),
        __metadata("design:type", PointDTO)
    ], CharacterPositionDTO.prototype, "point", void 0);
    return CharacterPositionDTO;
})();
exports.CharacterPositionDTO = CharacterPositionDTO;
let PositionCharactersEventDTO = (() => {
    class PositionCharactersEventDTO extends BattleEventDTO {
    }
    __decorate([
        class_validator_1.IsUUID(),
        __metadata("design:type", String)
    ], PositionCharactersEventDTO.prototype, "userId", void 0);
    __decorate([
        class_validator_1.IsArray(),
        class_transformer_1.Type(() => CharacterPositionDTO),
        class_validator_1.ValidateNested(),
        __metadata("design:type", Array)
    ], PositionCharactersEventDTO.prototype, "charactersPositions", void 0);
    return PositionCharactersEventDTO;
})();
exports.PositionCharactersEventDTO = PositionCharactersEventDTO;
let SkillEventDTO = (() => {
    class SkillEventDTO extends BattleEventDTO {
    }
    __decorate([
        class_validator_1.IsUUID(),
        __metadata("design:type", String)
    ], SkillEventDTO.prototype, "characterId", void 0);
    __decorate([
        class_validator_1.IsUUID(),
        __metadata("design:type", String)
    ], SkillEventDTO.prototype, "characterUserId", void 0);
    __decorate([
        class_validator_1.IsEnum(Skill_1.SkillsTypes),
        __metadata("design:type", String)
    ], SkillEventDTO.prototype, "skillType", void 0);
    __decorate([
        class_validator_1.IsArray(),
        class_transformer_1.Type(() => TargetCharacterDTO),
        class_validator_1.ValidateNested(),
        __metadata("design:type", Array)
    ], SkillEventDTO.prototype, "targetCharacters", void 0);
    __decorate([
        class_validator_1.IsArray(),
        class_transformer_1.Type(() => PointDTO),
        class_validator_1.ValidateNested(),
        __metadata("design:type", Array)
    ], SkillEventDTO.prototype, "points", void 0);
    return SkillEventDTO;
})();
exports.SkillEventDTO = SkillEventDTO;
let ImpactDTO = (() => {
    class ImpactDTO {
    }
    __decorate([
        class_validator_1.IsEnum(Character_1.CharacterStats),
        __metadata("design:type", String)
    ], ImpactDTO.prototype, "type", void 0);
    __decorate([
        class_validator_1.IsNumber(),
        __metadata("design:type", Number)
    ], ImpactDTO.prototype, "rawValue", void 0);
    __decorate([
        class_validator_1.IsNumber(),
        __metadata("design:type", Number)
    ], ImpactDTO.prototype, "value", void 0);
    return ImpactDTO;
})();
exports.ImpactDTO = ImpactDTO;
let TargetCharacterDTO = (() => {
    class TargetCharacterDTO {
    }
    __decorate([
        class_validator_1.IsUUID(),
        __metadata("design:type", String)
    ], TargetCharacterDTO.prototype, "characterId", void 0);
    __decorate([
        class_transformer_1.Type(() => ImpactDTO),
        class_validator_1.ValidateNested(),
        __metadata("design:type", ImpactDTO)
    ], TargetCharacterDTO.prototype, "impact", void 0);
    __decorate([
        class_validator_1.IsArray(),
        class_transformer_1.Type(() => ImpactDTO),
        class_validator_1.ValidateNested(),
        __metadata("design:type", Array)
    ], TargetCharacterDTO.prototype, "details", void 0);
    return TargetCharacterDTO;
})();
exports.TargetCharacterDTO = TargetCharacterDTO;
let GoalEventDTO = (() => {
    class GoalEventDTO extends BattleEventDTO {
    }
    __decorate([
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], GoalEventDTO.prototype, "name", void 0);
    __decorate([
        class_validator_1.IsArray(),
        class_transformer_1.Type(() => PointDTO),
        class_validator_1.ValidateNested(),
        __metadata("design:type", Array)
    ], GoalEventDTO.prototype, "points", void 0);
    return GoalEventDTO;
})();
exports.GoalEventDTO = GoalEventDTO;
let GoalInitEventDTO = (() => {
    class GoalInitEventDTO extends BattleEventDTO {
    }
    __decorate([
        class_validator_1.IsEnum(Battle_1.Difficulty),
        __metadata("design:type", String)
    ], GoalInitEventDTO.prototype, "difficulty", void 0);
    return GoalInitEventDTO;
})();
exports.GoalInitEventDTO = GoalInitEventDTO;
let EndBattleEventDTO = (() => {
    class EndBattleEventDTO extends BattleEventDTO {
    }
    __decorate([
        class_validator_1.IsEnum(Battle_1.Teams),
        __metadata("design:type", String)
    ], EndBattleEventDTO.prototype, "victorTeam", void 0);
    return EndBattleEventDTO;
})();
exports.EndBattleEventDTO = EndBattleEventDTO;
let TimeoutEventDTO = (() => {
    class TimeoutEventDTO extends BattleEventDTO {
    }
    __decorate([
        class_validator_1.IsUUID(),
        __metadata("design:type", String)
    ], TimeoutEventDTO.prototype, "userId", void 0);
    return TimeoutEventDTO;
})();
exports.TimeoutEventDTO = TimeoutEventDTO;
class ArenaWaveSpawnDTO extends BattleEventDTO {
}
exports.ArenaWaveSpawnDTO = ArenaWaveSpawnDTO;
class GenericMonsterWaveDTO extends BattleEventDTO {
}
exports.GenericMonsterWaveDTO = GenericMonsterWaveDTO;
class InitialMonsterWaveDTO extends BattleEventDTO {
}
exports.InitialMonsterWaveDTO = InitialMonsterWaveDTO;
let OpenChestDTO = (() => {
    class OpenChestDTO extends BattleEventDTO {
    }
    __decorate([
        class_validator_1.IsUUID(),
        __metadata("design:type", String)
    ], OpenChestDTO.prototype, "ChestId", void 0);
    return OpenChestDTO;
})();
exports.OpenChestDTO = OpenChestDTO;
class LootSummaryDTO {
}
exports.LootSummaryDTO = LootSummaryDTO;
let GetByBattleIdDTO = (() => {
    class GetByBattleIdDTO {
    }
    __decorate([
        class_validator_1.IsUUID(),
        __metadata("design:type", String)
    ], GetByBattleIdDTO.prototype, "battleId", void 0);
    return GetByBattleIdDTO;
})();
exports.GetByBattleIdDTO = GetByBattleIdDTO;
let AddBattleEventDTO = (() => {
    class AddBattleEventDTO {
    }
    __decorate([
        class_validator_1.ValidateNested(),
        class_transformer_1.Type(() => BattleEventDTO),
        __metadata("design:type", BattleEventDTO)
    ], AddBattleEventDTO.prototype, "event", void 0);
    return AddBattleEventDTO;
})();
exports.AddBattleEventDTO = AddBattleEventDTO;
//# sourceMappingURL=BattleEvent.js.map